// Human-readable training/run durations, shared by the modeling container and the chat blocks so
// "4m 2s" never renders as "4m 2s" in one place and "242.0s" in another.

/**
 * Format a duration in seconds as "1h 23m 4s", "12m 3s", or "59s".
 * Sub-second durations round up to "1s" rather than "0s" — a completed run always took some time.
 * Returns null for a missing or non-finite value, so callers can omit the segment entirely.
 */
export const formatDuration = (totalSeconds) => {
  const value = Number(totalSeconds);
  if (totalSeconds == null || !isFinite(value)) return null;

  const s = Math.max(1, Math.floor(value));
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || hours > 0) parts.push(`${minutes}m`);
  parts.push(`${seconds}s`);

  return parts.join(' ');
};

export default formatDuration;
